<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody } from '@sveltestrap/sveltestrap';

  import { PasswordField, SwitchField, TextField } from '@client/components/fields/standalone';
  import { ScrollableSection } from '@client/components/scrollspy';

  import { disabledValue, enabledValue } from '@client/pages/manage/domain-settings';

  export let settings = {};
  export let onUpdate = null;
</script>

<div id="crm">
  <ScrollableSection id="crm-salesforce">
    <h1 class="mb-3">{$format('label.SALESFORCE')}</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <SwitchField
          id="sfdcsandbox"
          label={$format('label.SANDBOX_MODE')}
          tooltip={$format('label.TOOLTIP.SANDBOX_MODE')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          {onUpdate}
          bind:checked={settings.sfdcsandbox}
        />

        <SwitchField
          id="sfdcautosetbcc"
          label={$format('label.AUTO_POPULATE_BCC')}
          tooltip={$format('label.TOOLTIP.AUTO_POPULATE_BCC')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          {onUpdate}
          bind:checked={settings.sfdcautosetbcc}
        />

        <SwitchField
          id="sfdcautoenabletracking"
          label={$format('label.AUTO_ENABLE_TRACKING')}
          tooltip={$format('label.TOOLTIP.AUTO_ENABLE_TRACKING')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          {onUpdate}
          bind:checked={settings.sfdcautoenabletracking}
        />

        <TextField
          id="sfdcadmin"
          label={$format('label.ADMIN_EMAIL')}
          tooltip={$format('label.TOOLTIP.ADMIN_EMAIL')}
          {onUpdate}
          bind:value={settings.sfdcadmin}
          allowCopy
        />

        <TextField
          id="sfdcinstance"
          label={$format('label.API_ENDPOINT')}
          tooltip={$format('label.TOOLTIP.API_ENDPOINT')}
          {onUpdate}
          bind:value={settings.sfdcinstance}
          allowCopy
        />

        <TextField
          id="sfdcuserfields"
          label={$format('label.USER_FIELD_LIST')}
          tooltip={$format('label.TOOLTIP.USER_FIELD_LIST')}
          {onUpdate}
          bind:value={settings.sfdcuserfields}
          allowCopy
        />

        <TextField
          id="sfdcuserfilters"
          label={$format('label.USER_FILTERS')}
          tooltip={$format('label.TOOLTIP.USER_FILTERS')}
          {onUpdate}
          bind:value={settings.sfdcuserfilters}
          allowCopy
        />

        <SwitchField
          id="sfdcincludeinactive"
          label={$format('label.SYNC_INACTIVE_USERS')}
          tooltip={$format('label.TOOLTIP.SYNC_INACTIVE_USERS')}
          valueOn={$format(enabledValue)}
          valueOff={$format(disabledValue)}
          {onUpdate}
          bind:checked={settings.sfdcincludeinactive}
        />
      </CardBody>
    </Card>
  </ScrollableSection>

  <ScrollableSection id="crm-surefire">
    <h1 class="mb-3">Surefire</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <TextField
          id="surefireendpoint"
          label={$format('label.API_ENDPOINT')}
          tooltip={$format('label.TOOLTIP.API_ENDPOINT_SUREFIRE')}
          {onUpdate}
          bind:value={settings.surefireendpoint}
          allowCopy
        />

        <TextField
          id="surefireclientkey"
          label={$format('label.CLIENT_KEY')}
          tooltip={$format('label.TOOLTIP.CLIENT_KEY')}
          {onUpdate}
          bind:value={settings.surefireclientkey}
          allowCopy
        />

        <PasswordField
          label={$format('label.API_KEY')}
          tooltip={$format('label.TOOLTIP.API_KEY')}
          {onUpdate}
          id="surefireapikey"
          bind:value={settings.surefireapikey}
          allowCopy
        />
      </CardBody>
    </Card>
  </ScrollableSection>

  <ScrollableSection id="crm-totalexpert">
    <h1 class="mb-3">TotalExpert</h1>

    <Card>
      <CardBody class="p-4 pt-1">
        <TextField
          id="totalexpertinstance"
          label={$format('label.API_ENDPOINT')}
          tooltip={$format('label.TOOLTIP.API_ENDPOINT_TOTALEXPERT')}
          {onUpdate}
          bind:value={settings.totalexpertinstance}
          allowCopy
        />

        <TextField
          id="totalexpertclientid"
          label={$format('label.CLIENT_ID')}
          tooltip={$format('label.TOOLTIP.CLIENT_ID')}
          {onUpdate}
          bind:value={settings.totalexpertclientid}
          allowCopy
        />

        <PasswordField
          id="totalexpertclientsecret"
          label={$format('label.CLIENT_SECRET')}
          tooltip={$format('label.TOOLTIP.CLIENT_SECRET')}
          {onUpdate}
          bind:value={settings.totalexpertclientsecret}
          allowCopy
        />

        <TextField
          id="totalexpertuserfilters"
          label={$format('label.USER_FILTERS')}
          tooltip={$format('label.TOOLTIP.USER_FILTERS_TOTALEXPERT')}
          {onUpdate}
          bind:value={settings.totalexpertuserfilters}
          allowCopy
        />
      </CardBody>
    </Card>
  </ScrollableSection>
</div>

<style lang="scss" src="./crm.scss"></style>
